import axios from 'axios';
import Util from '../Util'

class NotificationAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    
    list(){

        let path = "/api/notifications";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.get(endpoint).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }


    putAlreadyRead(notificationId){

        let path = "/api/notifications/" + notificationId + "/read";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.put(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }


}

let _api = new NotificationAPI();

export default _api;